import React, { useState, useEffect } from "react";
import { getAmendmentTaskSubType } from "../../../Organization/actions/payrun";
import { mustBeArray, errorHandler } from "../../../libs/utilities";
import { ListSelectField } from "../../ui";
import _ from "lodash";
import { useAppDispatch } from "../../../hooks";

type Props = {
  required: boolean;
  businessUnitId?: string;
  customLabel?: string;
  onChange?: (e: any, itemSelected: string) => void;
  task: any;
  updateSubTypeList: (list: Array<any>) => void;
};

const onChangeDefault = () => {
  console.log("");
};

const TerminationType = ({
  required,
  businessUnitId,
  onChange = onChangeDefault,
  task,
  updateSubTypeList,
}: Props) => {
  const dispatch: any = useAppDispatch();
  const [list, setList] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  // Get termination subtypes
  useEffect(() => {
    setList([]);
    setLoading(true);
    dispatch(
      getAmendmentTaskSubType({
        changeTaskValueId: task.changeTaskValueId,
        businessUnitId,
      })
    ).then((response: any) => {
      setLoading(false);
      if (response.status) {
        setList(_.sortBy(mustBeArray(response.data), (o) => o.name));
        updateSubTypeList(mustBeArray(response.data));
      } else {
        errorHandler({ response, hasValidationErrors: true });
      }
    });
  }, [task]);

  const handleOnChange = (optionID: number) => {
    const itemSelected = list.find((item: any) => item.id === optionID);
    onChange(optionID, itemSelected.name);
  };

  return (
    <ListSelectField
      label="Termination Reason"
      name="changeTaskSubType"
      className="mb-3  col-start-1"
      required={required}
      ruleMsg="Please select termination reason"
      onChange={handleOnChange}
      list={list}
      loading={loading}
    />
  );
};

export default TerminationType;
